<div class="login-container">
  <div class="card-container">
    <div class="title">Connexion</div>

    <ng-container *ngIf="!twoFactor">
      <div class="subtitle fs-16">
        Connectez vous en utilisant votre adresse mail renseignée lors de la
        création de votre compte
      </div>
      <div class="mt-3" (keyup.enter)="handleLogin()">
        <app-custom-input
          label="Email"
          [parentForm]="form"
          controlName="email"
        ></app-custom-input>
      </div>
      <div class="mt-3" (keyup.enter)="handleLogin()">
        <app-custom-input
          label="Mot de passe"
          type="password"
          [parentForm]="form"
          controlName="password"
        ></app-custom-input>
      </div>
      <app-button
        text="Connexion"
        [loading]="loading"
        [disabled]="form.invalid || loading"
        innerClass="mt-3 w-100"
        (handleClick)="handleLogin()"
      ></app-button>
      <div
        class="text-action text-center cursor-pointer fs-16 mt-3"
        routerLink="/forgot-password"
      >
        Mot de passe oublié?
      </div>
    </ng-container>

    <ng-container *ngIf="twoFactor">
      <div class="subtitle fs-16">
        Pour sécuriser votre compte, nous avons envoyé un code de vérification à
        <b>{{ twoFactor.maskedEmail }}</b>. Saisissez-le ci-dessous (valable 5 minutes).
      </div>
      <div class="mt-3" (keyup.enter)="verifyCode()">
        <app-custom-input
          label="Code de vérification"
          placeholder="123456"
          [parentForm]="codeForm"
          controlName="code"
          [errorMessage]="codeError"
        ></app-custom-input>
      </div>
      <app-button
        text="Valider"
        [loading]="loading"
        [disabled]="codeForm.invalid || loading"
        innerClass="mt-3 w-100"
        (handleClick)="verifyCode()"
      ></app-button>
      <div class="d-flex justify-content-between align-items-center mt-3 fs-14">
        <span class="text-action cursor-pointer" (click)="backToCredentials()">← Retour</span>
        <span
          class="cursor-pointer"
          [class.text-action]="resendIn === 0"
          [class.text-secondary]="resendIn > 0"
          (click)="resendCode()"
        >
          {{ resendIn > 0 ? 'Renvoyer le code dans ' + resendIn + ' s' : 'Renvoyer le code' }}
        </span>
      </div>
    </ng-container>
  </div>
</div>
